import Vue from 'vue'
import App from './App.vue'
import VueApexCharts from 'vue-apexcharts'
import router from './router'
import store from './store'
import '@mdi/font/css/materialdesignicons.css'
import Buefy from 'buefy'
import i18n from './i18n'
import './assets/nunito-font/stylesheet.scss'
import './axiosInterceptor'
import round from 'vue-round-filter'

Vue.config.productionTip = false
Vue.use(Buefy)
Vue.use(VueApexCharts)

Vue.component('apexchart', VueApexCharts)

new Vue({
  filters: {
    round,
  },
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
